import React from 'react';
import { Center, Container } from '@fiverr-private/layout_components';
import { Loader, ProgressLine } from '@fiverr-private/feedback';
import { Typography } from '@fiverr-private/typography';
import { I18n } from '@fiverr-private/i18n-react';
import type { UploadingBodyProps } from '../types';

const UploadingBody = ({ acceptedFiles = [], progressPercent, variant, theme }: UploadingBodyProps) => {
  const isSingleFileUploading = acceptedFiles.length === 1;
  if (variant === 'lean') {
    return (
      <Center width={42} height={42} paddingTop="1">
        <Loader size="sm" color={theme === 'dark' ? 'grey_300' : undefined} />
      </Center>
    );
  }

  return (
    <Center direction="column" gap="6">
      {isSingleFileUploading ? (
        <Typography textAlign="center" fontWeight="semibold" color={theme === 'dark' ? 'grey_300' : 'bodyPrimary'}>
          ‘{acceptedFiles[0].name}’
        </Typography>
      ) : (
        <Typography color={theme === 'dark' ? 'grey_300' : 'bodyPrimary'}>
          <I18n
            k="dropzone.uploading_body.files_count"
            templates={{
              count: (text?: string) => (
                <Typography as="span" fontWeight="semibold" color={theme === 'dark' ? 'grey_300' : 'bodyPrimary'}>
                  {text}
                </Typography>
              ),
            }}
            params={{ count: acceptedFiles.length }}
          />
        </Typography>
      )}
      <Container width="230px">
        <ProgressLine percent={progressPercent} />
      </Container>
    </Center>
  );
};

UploadingBody.displayName = 'UploadingBody';
UploadingBody.id = 'UploadingBody';

export default UploadingBody;
